import { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { getSentEmails, generatePdf } from "../api";
import { toast } from "../components/Toast";
import "./SentEmailsPage.css";

export default function SentEmailsPage() {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);

  const departmentData = JSON.parse(localStorage.getItem("department")) || {};
  const isSuperuser = departmentData.is_superuser || false;

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const data = await getSentEmails();
        setEmails(Array.isArray(data) ? data : data.results || []);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    }
    load();
  }, []);

  function formatDate(dateStr) {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("ka-GE", {
      day: "numeric", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  }

  async function handleDownloadPdf() {
    if (!selectedEmail?.reply) return;
    setPdfLoading(true);
    try {
      const content = selectedEmail.reply.final_reply_content || selectedEmail.reply.gpt_generated_reply;
      const blob = await generatePdf(selectedEmail.id, content);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `reply-${selectedEmail.id}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      toast(err.message, "error");
    }
    setPdfLoading(false);
  }

  return (
    <div className="dash-root">
      <Header />
      <div className="dash-layout">
        <Sidebar activePage="sent" isSuperuser={isSuperuser} />

        <div className="sent-content">
          <h2 className="sent-page-title">გაგზავნილი წერილები</h2>

          {loading ? (
            <div className="sent-loading">იტვირთება...</div>
          ) : emails.length === 0 ? (
            <div className="sent-empty">გაგზავნილი წერილები არ არის</div>
          ) : (
            <div className="sent-layout">
              <div className="sent-list">
                {emails.map((email) => (
                  <div
                    key={email.id}
                    className={`sent-card ${selectedEmail?.id === email.id ? "selected" : ""}`}
                    onClick={() => setSelectedEmail(email)}
                  >
                    <div className="sent-card-top">
                      <span className="sent-card-to">{email.from_email}</span>
                      <span className="sent-card-date">{formatDate(email.reply?.sent_at)}</span>
                    </div>
                    <div className="sent-card-subject">Re: {email.subject}</div>
                    <div className="sent-card-badges">
                      {email.department_names?.map((name) => (
                        <span key={name} className="sent-dept-tag">{name}</span>
                      ))}
                      {email.reply?.status === "sent" && (
                        <span className="sent-status-tag">გაგზავნილი</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {selectedEmail && (
                <div className="sent-detail">
                  <div className="sent-detail-header">
                    <h3>Re: {selectedEmail.subject}</h3>
                  </div>
                  <div className="sent-detail-meta">
                    <div className="sent-meta-row">
                      <span className="sent-meta-label">მიმღები:</span>
                      <span>{selectedEmail.from_email}</span>
                    </div>
                    <div className="sent-meta-row">
                      <span className="sent-meta-label">თარიღი:</span>
                      <span>{formatDate(selectedEmail.reply?.sent_at)}</span>
                    </div>
                    <div className="sent-meta-row">
                      <span className="sent-meta-label">გამგზავნი:</span>
                      <span>{selectedEmail.department_names?.join(", ") || selectedEmail.department_name}</span>
                    </div>
                    <div className="sent-meta-row">
                      <span className="sent-meta-label">სტატუსი:</span>
                      <span>{selectedEmail.reply?.was_edited ? "რედაქტირებული და გაგზავნილი" : "გაგზავნილი"}</span>
                    </div>
                  </div>

                  <div className="sent-original-section">
                    <div className="sent-section-label">ორიგინალი წერილი</div>
                    <div className="sent-original-body">
                      <div><strong>გამომგზავნი:</strong> {selectedEmail.from_email}</div>
                      <div><strong>თემა:</strong> {selectedEmail.subject}</div>
                      <div className="sent-original-text">{selectedEmail.text_body}</div>
                    </div>
                  </div>

                  <div className="sent-reply-section">
                    <div className="sent-section-label">გაგზავნილი პასუხი</div>
                    <div className="sent-reply-body">
                      {selectedEmail.reply?.final_reply_content || selectedEmail.reply?.gpt_generated_reply}
                    </div>
                  </div>

                  <div className="sent-actions">
                    <button
                      className="sent-pdf-btn"
                      onClick={handleDownloadPdf}
                      disabled={pdfLoading}
                    >
                      {pdfLoading ? "იტვირთება..." : "PDF ჩამოტვირთვა"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
